import React from 'react';
import Link from 'gatsby-link';

import '../scss/header.scss';

export default function Header({ children, className, to }) {
  return (
    <header className="header">
      <div className="content">
        <strong className="logo">
          <Link to="/">Денис Бородин</Link>
        </strong>
        <ul className="header__nav">
            <li><Link to="/about">Обо мне</Link></li>
            <li><a target="_blank" href="//github.com/BorodinDK">GitHub</a></li>
            <li><a target="_blank" href="//facebook.com/BorodinDenis">Facebook</a></li>
        </ul>
      </div>
    </header>
  );
}



// WEBPACK FOOTER //
// ./src/components/Header.js